import { ActionContext } from 'vuex';
import { IApiResponse, IMetaResponse, IWebhook } from '@/shared';
import webhook from '@/shared/services/webhooks';

export default {
  namespaced: true,
  state: {
    single: undefined,
    testSingle: undefined,
  },
  getters: {
    single: (state: any): IWebhook => {
      if (state.single) return { ...state.single?.data };
      return {} as IWebhook;
    },
    testSingle: (state: any): IWebhook => {
      if (state.testSingle) return { ...state.single?.data };
      return {} as IWebhook;
    },
  },
  mutations: {
    set: (state: any, payload: IApiResponse<IWebhook, IMetaResponse>) => {
      state.single = { ...payload };
    },
    setTest: (state: any, payload: IApiResponse<IWebhook, IMetaResponse>) => {
      state.testSingle = { ...payload };
    },
    reset: (state: any) => {
      state.single = {};
    },
  },
  actions: {
    get: async (ctx: ActionContext<any, any>, clientId: number) => {
      const result = await webhook.get(clientId);
      ctx.commit('set', result);
    },
    post: async (ctx: ActionContext<any, any>, payload: IWebhook) => {
      const result = await webhook.post(payload);
      ctx.commit('set', result);
    },
    testGet: async (ctx: ActionContext<any, any>, webhookId: string) => {
      const result = await webhook.testGet(webhookId);
      ctx.commit('setTest', result);
    },
    reset: (ctx: ActionContext<any, any>) => {
      ctx.commit('reset');
    },
  },
};
